<!-- Content -->
@if (trainingSharedFacade.quizStartData$ | async; as quizStartData) {
  @for (chapter of quizStartData.items | sortBy_shared:'asc':'position'; track chapter.id) {
    <medsurf-design-content-panel
      [titleText]="chapter.page.title"
      [contentClass]="'mt-2'"
      [toggleable]="true">
      <!-- Block Table -->
      <p-table [value]="chapter.children | sortBy_shared:'asc':'position'"
        [rowTrackBy]="rowTrackBy"
        selectionMode="single"
        (onRowSelect)="onRowSelect($event)"
        sortField="key">
        <ng-template pTemplate="body"
          let-blockData>
          <tr [pSelectableRow]="blockData.id">
            <td>
              {{ blockData.page.title }}
            </td>
            <td class="w-1">
              {{ blockData.nodeIds.length || 0 }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </medsurf-design-content-panel>
  }
} @else {
  <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
  <br/>
}
